<script setup>
import useGrid from "@/composables/useGrid";
import needsService from "@/services/needs.service";
import Grid from "../../../../frontend/src/components/Grid.vue";
import {onMounted, ref} from "vue";
import EcosystemNeedsModal from "@/views/needs/EcosystemNeedsModal.vue";

const {items, gridParams, gridMethods} = useGrid(needsService.getEcosystems);

const columns = [
    {
        label: 'ID',
        name: 'id',
        sortable: true,
    },
    {
        label: 'Name',
        name: 'name',
        sortable: true,
        filter: 'text',
    },
    {
        label: 'Short Description',
        name: 'shortDescription',
    },
    {
        label: 'Domain',
        name: 'url_domain',
        sortable: true,
        filter: 'text',
    },
    {
        label: 'Has Account',
        name: 'has_account',
        sortable: true,
        filter: 'single-select',
        options: [
            {
                id: 'yes',
                name: 'Yes'
            },
            {
                id: 'no',
                name: 'No'
            },
        ],
    },
    {
        label: 'Admin Email',
        name: 'email',
        sortable: true,
        filter: 'text',
    },
    {
        label: 'Matched Shared Needs',
        name: 'shared_count',
        sortable: true,
        component: 'Link',
    },
    {
        label: 'Matched Private Needs',
        name: 'private_count',
        sortable: true,
        component: 'Link',
    },
    {
        label: 'Submitted Startups',
        name: 'submitted_startups_count',
        sortable: true,
    },
];

const ecosystemNeeds = ref(null);

onMounted(() => {
    gridParams.sort = {
        field: 'shared_count',
        dir: 'desc',
    };

    gridMethods.setColumns(columns);
    gridMethods.resetList();
});

function action(params) {
    if (params.action === 'show_shared_count') {
        ecosystemNeeds.value.open(params.rowId, 'shared');
    }
    if (params.action === 'show_private_count') {
        ecosystemNeeds.value.open(params.rowId, 'private');
    }
}

</script>

<template>
    <div>
        <div class="topbar">
            <div class="tabs tabs-primary">
                <b-nav tabs>
                    <b-nav-item :to="{ name: 'needs' }">
                        Needs
                    </b-nav-item>

                    <b-nav-item  active>
                        Ecosystems
                    </b-nav-item>
                </b-nav>
            </div>
        </div>

        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <Grid
                    :columns="columns"
                    :data="items"
                    has-filters
                    has-checkbox-column
                    :page-length="parseInt(gridParams.pageLength)"
                    :total-rows-count="gridParams.totalRowsCount"
                    :sort="gridParams.sort"
                    :currentPage="gridParams.currentPage"
                    @changePage="gridMethods.changePage"
                    @changeFilters="gridMethods.setFilters"
                    @changeSort="gridMethods.changeSort"
                    @selectedRowsChanged="gridMethods.changeSelectedRows"
                    @action="action"
                />
            </div>
        </div>

        <EcosystemNeedsModal ref="ecosystemNeeds"/>
    </div>
</template>

<style scoped>

</style>
